import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

import { ReactComponent as Check } from "../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledEvaluationSelect = styled.div`
  margin: ${multiple / 2 + "px"} 0;
  .evaluationSelectWrapper {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
    .optionWrapper {
      background-color: ${nota.color.neutral.NeuFour};
      width: 100%;
      cursor: pointer;
      margin-bottom: ${multiple / 2 + "px"};
      padding: 6px;

      .checkBoxWrapper {
        height: 100%;
        width: 25px;
        padding-right: 5px;
        svg {
          width: 13px;
          height: auto;
          path {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }
      p {
        width: calc(100% - 25px);
        font-size: 12px;
      }

      &:hover {
        opacity: 0.7;
      }
    }
    .selectedOption {
      background-color: ${nota.color.main.default};
      p {
        color: ${nota.color.neutral.white};
      }
      .checkBoxWrapper {
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }
`;

class EvaluationSelect extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.selected,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected && this.props.onChangeSelection) {
      this.props.onChangeSelection({ selected: this.state.selected });
    }

    if (prevProps.selected !== this.props.selected || this.props.forceSelection) {
      this.setState({ selected: this.props.selected });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onClick = () => {
    this.setState({ selected: !this.state.selected });
  };

  render() {
    return (
      <StyledEvaluationSelect>
        <NanoFlex className="evaluationSelectWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className={`optionWrapper ${this.state.selected ? "selectedOption" : ""}`} onClick={this.onClick}>
            <NanoFlex className="checkBoxWrapper">
              <Check />
            </NanoFlex>
            <Type.p>{this.translation.advancedSearch.evaluation.subTitle}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledEvaluationSelect>
    );
  }
}

// Set default props
EvaluationSelect.defaultProps = {};

export default EvaluationSelect;

// --- // Documentation // --- //
/*
import EvaluationSelect from './../Nano/EvaluationSelect.js';

<EvaluationSelect />
*/
